//Context store for registration wizard
import React, { useState } from 'react';

const CollectionsContext = React.createContext([{}, p => {}]);

const CollectionsProvider = (props) => {
    const [collectionsState, setCollectionsState] = useState({
        cohortCollections: [
            {
                _id: "",
                Title: "Loading...",
                Description: "Loading...",
            }
        ],
        cohortCollection:
            {
                _id: "",
                Title: "",
                Description: ""
            },
        cohortImages: [
            {
                _id: "",
                Title: "Loading...",
                Description: "Loading...",
                Location: "Loading...",
                Caption: "Loading...",
                Value: "Loading...",
                Image: "Loading...",
                ImagePublicId: "Loading..."
            }
        ],
        cohortImage:
            {
                _id: "",
                Title: "",
                Description: "",
                Location: "",
                Caption: "",
                Value: "",
                Image: "",
                ImagePublicId: "",
                imageChanged: false
            },
        tourneyCollections: [
            {
                _id: "",
                Title: "Loading...",
                Description: "Loading...",
            }
        ],
        tourneyCollection:
            {
                _id: "",
                Title: "",
                Description: ""
            },
        tourneyImages: [
            {
                _id: "",
                Title: "Loading...",
                Description: "Loading...",
                Location: "Loading...",
                Caption: "Loading...",
                Value: "Loading...",
                Image: "Loading...",
                ImagePublicId: "Loading..."
            }
        ],
        tourneyImage:
            {
                _id: "",
                Title: "",
                Description: "",
                Location: "",
                Caption: "",
                Value: "",
                Image: "",
                ImagePublicId: "",
                imageChanged: false
            },
        generalCollections: [
            {
                _id: "",
                Title: "Loading...",
                Description: "Loading...",
            }
        ],
        generalCollection:
            {
                _id: "",
                Title: "",
                Description: ""
            },
        generalImages: [
            {
                _id: "",
                Title: "Loading...",
                Description: "Loading...",
                Location: "Loading...",
                Caption: "Loading...",
                Value: "Loading...",
                Image: "Loading...",
                ImagePublicId: "Loading..."
            }
        ],
        generalImage:
            {
                _id: "",
                Title: "",
                Description: "",
                Location: "",
                Caption: "",
                Value: "",
                Image: "",
                ImagePublicId: "",
                imageChanged: false
            },
    });
    return (
        <CollectionsContext.Provider value={[collectionsState, setCollectionsState]}>
            {props.children}
        </CollectionsContext.Provider>
    );
};

export { CollectionsContext, CollectionsProvider };
